module.exports = __webpack_public_path__ + "static/media/help-icon.fd88b365.svg";